import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface DrawerLoadingStateProps {
  loading: boolean;
  error: string | null;
}

export const DrawerLoadingState: React.FC<DrawerLoadingStateProps> = ({ 
  loading, 
  error 
}) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return null;
};














